// Substituted at build (webpack/Vite define) or bundle deploy time.
declare global {
  var AI_AVATAR_URL: string | undefined;
  var ATTENTIVE_CLIENT_ID: string | undefined;
  var ATTENTIVE_OUTBOUND_USER_ID: string | undefined;
  var DATADOG_APPLICATION_ID: string | undefined;
  var DATADOG_CLIENT_TOKEN: string | undefined;
  var FACEBOOK_BUSINESS_CONFIG_ID: string | undefined;
  var FACEBOOK_CLIENT_ID: string | undefined;
  var FACEBOOK_USER_CONFIG_ID: string | undefined;
  var GMAIL_CLIENT_ID: string | undefined;
  var GORGIAS_CLIENT_ID: string | undefined;
  var INSTAGRAM_BUSINESS_CONFIG_ID: string | undefined;
  var OUTLOOK_CLIENT_ID: string | undefined;
  var REDO_API_URL: string | undefined;
  var REDO_CUSTOMER_PORTAL_URL: string | undefined;
  var REDO_EFFECT_API_URL: string | undefined;
  var REDO_MARKETING_OUTBOUND_USER_ID: string | undefined;
  var REDO_MERCHANT_APP_VERSION: string | undefined;
  var REDO_MERCHANT_SERVER_URL: string | undefined;
  var REDO_ONBOARDING_APP_URL: string | undefined;
  var REDO_SHOPIFY_SERVER_URL: string | undefined;
  var RYDER_AUTH_CALLBACK_URL: string | undefined;
  var RYDER_AUTH_URL: string | undefined;
  var RYDER_CLIENT_ID: string | undefined;
  var SHIPBOB_AUTH_CALLBACK_URL: string | undefined;
  var SHIPBOB_AUTH_URL: string | undefined;
  var SHIPBOB_CLIENT_ID: string | undefined;
  var SHIPBOB_INTEGRATION_NAME: string | undefined;
}

export const GORGIAS_CLIENT_ID = globalThis.GORGIAS_CLIENT_ID;

export const REDO_API_URL = globalThis.REDO_API_URL || "http://localhost:8888";

export const REDO_MERCHANT_APP_VERSION =
  globalThis.REDO_MERCHANT_APP_VERSION || "_";

export const REDO_MERCHANT_SERVER_URL =
  globalThis.REDO_MERCHANT_SERVER_URL || "http://localhost:8007";

// Origin of the onboarding app (setup.${domain}). Used for cross-app
// navigation from the merchant app and to validate the post-T&C
// server-resolved redirectUrl as an open-redirect guard. Must match
// getOnboardingAppUrl() in redo-onboarding-common/util/onboarding-app-url.ts.
export const REDO_ONBOARDING_APP_URL =
  globalThis.REDO_ONBOARDING_APP_URL || "http://localhost:13015";

export const REDO_SHOPIFY_SERVER_URL =
  globalThis.REDO_SHOPIFY_SERVER_URL || "http://localhost:8004";

export const REDO_CUSTOMER_PORTAL_URL =
  globalThis.REDO_CUSTOMER_PORTAL_URL || "http://localhost:3002";

export const FACEBOOK_CLIENT_ID = globalThis.FACEBOOK_CLIENT_ID;

export const FACEBOOK_USER_CONFIG_ID = globalThis.FACEBOOK_USER_CONFIG_ID;

export const FACEBOOK_BUSINESS_CONFIG_ID =
  globalThis.FACEBOOK_BUSINESS_CONFIG_ID;

export const INSTAGRAM_BUSINESS_CONFIG_ID =
  globalThis.INSTAGRAM_BUSINESS_CONFIG_ID;

export const ATTENTIVE_CLIENT_ID = globalThis.ATTENTIVE_CLIENT_ID;
export const AI_AVATAR_URL = globalThis.AI_AVATAR_URL;
export const GMAIL_CLIENT_ID = globalThis.GMAIL_CLIENT_ID;
export const OUTLOOK_CLIENT_ID = globalThis.OUTLOOK_CLIENT_ID;
export const ATTENTIVE_OUTBOUND_USER_ID = globalThis.ATTENTIVE_OUTBOUND_USER_ID;
export const REDO_MARKETING_OUTBOUND_USER_ID =
  globalThis.REDO_MARKETING_OUTBOUND_USER_ID;

export const SHIPBOB_AUTH_CALLBACK_URL =
  globalThis.SHIPBOB_AUTH_CALLBACK_URL || "";
export const SHIPBOB_CLIENT_ID = globalThis.SHIPBOB_CLIENT_ID || "";
export const SHIPBOB_AUTH_URL = globalThis.SHIPBOB_AUTH_URL || "";
export const SHIPBOB_INTEGRATION_NAME =
  globalThis.SHIPBOB_INTEGRATION_NAME || "";

export const RYDER_AUTH_CALLBACK_URL = globalThis.RYDER_AUTH_CALLBACK_URL || "";
export const RYDER_CLIENT_ID = globalThis.RYDER_CLIENT_ID || "";
export const RYDER_AUTH_URL =
  globalThis.RYDER_AUTH_URL || "https://www.getwhiplash.com";

export const DATADOG_APPLICATION_ID = globalThis.DATADOG_APPLICATION_ID ?? null;
export const DATADOG_CLIENT_TOKEN = globalThis.DATADOG_CLIENT_TOKEN ?? null;

export const REDO_EFFECT_API_URL =
  globalThis.REDO_EFFECT_API_URL || "http://localhost:3001";
